<template>
  <FeatureFlag feature="qbo_direct">
    <div
      v-if="qboMapping"
      class="link flex items-center"
      @click="confirmModalOpen = true"
    >
      <span class="d-flex-inline unlink">
        <QBBall class="qb-icon mr-1" />
        Unlink
      </span>
      <i class="fas fa-link-slash ml-1" />
    </div>
    <sera-modal
      :open="confirmModalOpen"
      @primary-action="handleUnlinkTask"
      @close="confirmModalOpen = false"
    >
      <template #header>
        <div>
          <h3 class="page-header-2">Unlink QuickBooks Mapping</h3>
        </div>
      </template>
      <div style="max-width: 400px">
        <p class="mb-4">
          Are you sure you want to unlink the mapping to QuickBooks?<br /><br />
          At the time of mapping, the item was called "{{ qboMapping.name }}" in
          QuickBooks. The name of this mapped item may have been changed since
          then.<br /><br />
          Once unlinked, the system will attempt to map this task by name the
          next time an invoice with this task is batched.
        </p>
      </div>
    </sera-modal>
  </FeatureFlag>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import FeatureFlag from "@/components/FeatureFlag.vue";
import QBBall from "@/Quickbooks/QBBall.vue";

const emit = defineEmits(["unlink-success"]);

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
});

const store = useStore();

const qboMapping = computed(() => {
  return props.item.qbo_mapping || null;
});

async function handleUnlinkTask() {
  await store.dispatch("unlinkQuickbooksMapping", qboMapping.value.id);

  confirmModalOpen.value = false;

  window.notify.success("Task mapping unlinked successfully!");

  emit("unlink-success");
}

const confirmModalOpen = ref(false);
</script>
<style scoped>
.unlink {
  position: relative;
  top: -3px;
}

.qb-icon {
  position: relative;
  top: -2px;
}
</style>
